export const TAG_NAME = {
	MAX_LENGTH: 20,
	MAX_MESSAGE: 'Tag name cannot exceed 20 characters',
	REQUIRED_MESSAGE: 'Please enter a tag name'
};
